export default [{type:"image\u002Fwebp",srcset:".\u002Fassets\u002Fmiya.3229ce75.webp 325w",loading:"lazy",src:".\u002Fassets\u002Fmiya.3229ce75.webp"}]